import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {UserAccountFacade} from '@spartacus/user/account/root';
import {AimoRoutingService} from './features/cms-structure/routing/aimo-routing.service';
import {AimoHamburgerMenuService} from './features/layout/hamburger-menu/aimo-hamburger-menu.service';
import {AimoGtmService} from './features/service/gtm/aimo-gtm.service';
import {AimoWebextendService} from './features/service/webextend/aimo-webextend.service';
import {Meta} from "@angular/platform-browser";
import {AimoUser} from "./features/model/user.model";
import {map} from "rxjs/operators";
import {OCC_USER_ID_ANONYMOUS} from "@spartacus/core";

@Component({
    selector: 'aimo-root',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit, OnDestroy {
    title: string = 'Aimo';
    isExpanded$: Observable<boolean>;
    subscriptions: Subscription = new Subscription();

    constructor(
        private hamburgerMenuService: AimoHamburgerMenuService,
        protected aimoRoutingService: AimoRoutingService,
        protected gtmService: AimoGtmService,
        protected aimoWebextendService: AimoWebextendService,
        protected activatedRoute: ActivatedRoute,
        protected userAccountFacade: UserAccountFacade,
        private metaService: Meta
    ) {
        this.isExpanded$ = this.hamburgerMenuService.isExpanded;
    }

    isPikatukku(): boolean {
        return this.aimoRoutingService.isPikatukku();
    }

    ngAfterViewInit() {
        const gtmUrlParam = this.activatedRoute.snapshot.queryParamMap.get('_gl');
        this.gtmService.addToDom(gtmUrlParam);
        this.aimoWebextendService.initWebextend();
        this.addQualtricsMeta();
    }

    private addQualtricsMeta() :void{
        this.subscriptions.add(this.userAccountFacade.get()
            .pipe(map(user1 => user1 as AimoUser))
            .subscribe(user1 => {
                const uid = user1?.uid;
                if (uid != undefined && uid !== OCC_USER_ID_ANONYMOUS) {
                    this.addOrUpdateTag('userId', user1.uid);
                    this.addOrUpdateTag('email', user1.email);
                    this.addOrUpdateTag('CustomerCompany', user1.unit?.name);
                    this.addOrUpdateTag('PhoneNumber', user1.unit?.addresses[0]?.phone);
                    this.addOrUpdateTag('CustomerID', user1.unit?.uid);
                } else {
                    this.metaService.removeTag("name='userId'");
                    this.metaService.removeTag("name='email'");
                    this.metaService.removeTag("name='CustomerCompany'");
                    this.metaService.removeTag("name='PhoneNumber'");
                    this.metaService.removeTag("name='CustomerID'");
                }
            }));
    }

    private addOrUpdateTag(metaSelector: string, newContent: string):void {
        const qualtricsId = "qualtrics_" + metaSelector;
        if (!this.metaService.getTag("name=" + metaSelector)) {
            this.metaService.updateTag({
                name: metaSelector,
                id: qualtricsId,
                content: newContent
            }, "name=" + metaSelector);
        } else {
            this.metaService.addTag({name: metaSelector, id: qualtricsId, content: newContent});
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
